var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import { ellipsis, emDash, inputRules, smartQuotes, textblockTypeInputRule, wrappingInputRule, } from 'prosemirror-inputrules';
import { schema } from './schema';
export var rules = function () {
    return inputRules({
        rules: __spreadArray(__spreadArray([], smartQuotes), [
            ellipsis,
            emDash,
            // > blockquote
            wrappingInputRule(/^\s*>\s$/, schema.nodes.blockquote),
            // 1. ordered list
            wrappingInputRule(/^(\d+)\.\s$/, schema.nodes.list, function (match) {
                return { type: 'ordered', start: +match[1] };
            }, function (match, node) {
                return node.childCount + Number(node.attrs.start) === +match[1];
            }),
            // * bullet list
            wrappingInputRule(/^\s*\*\s$/, schema.nodes.list, function () {
                return { type: 'bullet' };
            }),
            // ``` code block
            textblockTypeInputRule(/^```$/, schema.nodes.codeBlock),
            // # heading
            textblockTypeInputRule(new RegExp('^(#{1,6})\\s$'), schema.nodes.heading, function (match) {
                return { level: match[1].length };
            }),
        ]),
    });
};
